import V1 from './V1';
import V3 from './V3';
import V4 from './V4';

import {VersionVariants} from '@jobseeker/lotus/enums';
import type {
  SelectProps as MuiSelectProps,
  SxProps,
  Theme,
} from '@mui/material';

type MuiProps = Pick<
  MuiSelectProps,
  | 'onChange'
  | 'sx'
  | 'label'
  | 'multiple'
  | 'value'
  | 'name'
  | 'error'
  | 'MenuProps'
>;
export interface OptionType {
  value: string | number;
  id?: string | number;
  label: string;
  selected?: string[] | number[];
}

export interface OptionTypeExtended extends OptionType {
  options?: OptionType[];
}
export interface SelectProps extends MuiProps {
  variant: string | VersionVariants;
  options: OptionTypeExtended[];
  menuOpen?: boolean;
  maxWidth?: number;
  truncatelength?: number;
  setMenuOpen?: (value: any) => void;
  helperText?: string | undefined | false;
  placeholder?: string;
  sx?: SxProps<Theme> | undefined;
  hirist?: boolean;
  hiristColor?: boolean;
  name?: string;
  page?: string;
  tooltip?: any;
}

let componentMap: {[key: string]: any} = {};

componentMap[VersionVariants.VERSION_ONE] = V1;
componentMap[VersionVariants.VERSION_THREE] = V3;
componentMap[VersionVariants.VERSION_FOUR] = V4;

const Component = (props: SelectProps) => {
  let Component;
  if (Object.keys(componentMap).includes(props.variant)) {
    Component = componentMap[props.variant];
  } else {
    Component = componentMap[VersionVariants.VERSION_ONE];
  }
  return <Component {...props} />;
};

export default Component;
